import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    BarChart,
    Bar,
    AreaChart,
    Area,
    PieChart,
    Pie,
    Cell,
    Legend,
} from "recharts";
import { Trash2, GripVertical, } from "lucide-react";
import Spinner from "./spinner";

const CARD_TITLES = {
    line: "Histórico de Índice",
    bar: "Totales de Faltas",
    area: "Tendencia de Índice",
    pie: "Proporción de Faltas",
    malosconductores: "Conductores con Bajo Desempeño",
};

const COLORS = [
    "#8884d8",
    "#82ca9d",
    "#ffc658",
    "#ff7f50",
    "#00c49f",
    "#0088fe",
];

export default function ChartCard({ type, i, onRemove, datasets }) {
    const { lineData, barData, areaData, pieData, listadoCalificaciones } =
        datasets;
    const title = CARD_TITLES[type] || `Card ${i}`;

    // Condición de carga por tipo
    const isLoading =
        (type === "line" && !lineData.length) ||
        (type === "bar" && !barData.length) ||
        (type === "area" && !areaData.length) ||
        (type === "pie" && !pieData.length) ||
        (type === "malosconductores" && !listadoCalificaciones.length);

    return (
        <div className="h-full w-full bg-white rounded-2xl shadow-sm border border-neutral-200  overflow-hidden flex flex-col">
            <div className="flex items-center justify-between px-4 py-2 border-b border-neutral-200 ">
                <div className="flex items-center gap-2 text-sm font-medium">
                    <GripVertical className="drag-handle h-4 w-4 text-neutral-400" />
                    <span>{title}</span>
                </div>
                <button
                    onClick={() => onRemove(i)}
                    className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md border border-neutral-200  hover:bg-neutral-50"
                >
                    <Trash2 className="h-3.5 w-3.5" /> Quitar
                </button>
            </div>

            <div className="flex-1 p-2">
                {isLoading ? (
                    <Spinner />
                ) : (
                    <>
                        {type === "line" && (
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={lineData}>
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="value" />
                                </LineChart>
                            </ResponsiveContainer>
                        )}

                        {type === "bar" && (
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={barData}>
                                    <XAxis dataKey="day" />
                                    <YAxis />
                                    <Tooltip />
                                    <Bar dataKey="v" />
                                </BarChart>
                            </ResponsiveContainer>
                        )}

                        {type === "area" && (
                            <ResponsiveContainer width="100%" height="100%">
                                <AreaChart data={areaData}>
                                    <XAxis dataKey="t" />
                                    <YAxis />
                                    <Tooltip />
                                    <Area dataKey="v" type="monotone" fillOpacity={0.3} />
                                </AreaChart>
                            </ResponsiveContainer>
                        )}

                        {type === "pie" && (
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Tooltip />
                                    <Legend />
                                    <Pie
                                        data={pieData}
                                        dataKey="value"
                                        nameKey="name"
                                        outerRadius={80}
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={COLORS[index % COLORS.length]}
                                            />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        )}

                        {type === "malosconductores" && (
                            <div className="h-full w-full overflow-auto p-2">
                                {listadoCalificaciones[0]?.listaConductores?.length ? (
                                    listadoCalificaciones[0].listaConductores.map((c, idx) => (
                                        <div
                                            key={idx}
                                            className="text-sm"
                                            title={String(c.indiceTotal ?? "")}
                                        >
                                            • {c.conductor}
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-neutral-400 text-sm">Sin datos</div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

